export default {
  getPendingReview: state =>  {
    return state.pendingReview
  },
}